module.exports = __webpack_public_path__ + "static/promotion-content-070dc80b90c267be87371fc98ce00629.png";